export default "__VITE_ASSET__CsznCXvo__"